import { gql } from "@apollo/client";

export const MeetingsOverviewMeeting = gql`
  fragment MeetingsOverviewMeeting on MeetingNode {
    id
    title
    draft
    meetingGroupId
    ignored
    startDatetime
    endDatetime
    videoConferenceUrl
    videoConferenceType
    meetingGroup {
      id
      title
      description
      isFormalOneonone
    }
    creator {
      id
    }
    participants {
      edges {
        node {
          id
          user {
            id
          }
        }
      }
    }
  }
`;
